import React, { useContext, useState } from 'react'
import ILogin from './login.interface'
import LoginContext from './login-context'
import MessageContext from '../message/message-context'
import Spinner from '../spinner/spinner'
import api from '../../api'

const BankIdSignup: React.FC<ILogin> = () => {
  const { setBankIdSignup } = useContext(LoginContext)
  const { setMessage, setErrorMessage } = useContext(MessageContext)

  const [loading, setLoading] = useState(false)
  const [messages, setMessages] = useState({
    email: '',
    ssn: '',
  })
  const [name, setName] = useState('')
  const [ssn, setSsn] = useState('')
  const [email, setEmail] = useState('')
  const [accountName, setAccountName] = useState('')
  const [orgNumber, setOrgNumber] = useState('')

  const ssnRegex = RegExp('^[0-9]{12}$')
  const emailRegex = RegExp('^[^@]+@[^.]+..+$')

  const handleSignup = async () => {
    const validOrgNumber = validateOrgNumber(orgNumber)

    if (!validOrgNumber) {
      setErrorMessage(
        'Organisationsnummer i fel format. Ange i följande format: XXXXXX-XXXX (endast siffror)',
      )
      setLoading(false)
      return
    }

    try {
      if (name && ssn && email && accountName && orgNumber) {
        if (ssnRegex.test(ssn) && emailRegex.test(email)) {
          setLoading(true)

          const response = await api.post('/sign-ups', {
            name,
            ssn,
            email,
            accountName,
            orgNumber,
          })

          const data = response.data
          setLoading(false)
          if (data && data.data) {
            setMessage({
              value:
                'Tack för din förfrågan. Fastigo behandlar din ansökan och återkommer via mejl inom 2-3 arbetsdagar när du är registrerad.',
            })
            setName('')
            setSsn('')
            setEmail('')
            setAccountName('')
            setOrgNumber('')
          } else {
            setErrorMessage('Något gick fel')
          }
        } else {
          setErrorMessage('Felformaterade fält')
        }
      } else {
        setErrorMessage('Saknade fält')
      }
    } catch (e) {
      console.log(e)
      setErrorMessage('Något gick fel')

      setLoading(false)
    }
  }

  const containsOnlyNumbers = (orgNumber) => {
    return /^\d+$/.test(orgNumber)
  }

  const validateOrgNumber = (orgNumber) => {
    const orgNumberwithoutHyphens = orgNumber.replace(/-/g, '')

    if (orgNumberwithoutHyphens.length === 10 && containsOnlyNumbers(orgNumberwithoutHyphens)) {
      return true
    }
    return false
  }

  const handleBackToLogin = () => {
    setBankIdSignup(false)
  }

  return (
    <div className="h-screen flex font-sans flex-col items-center bg-bgBlueGray">
      <div className="mx-auto pb-12 mt-12">
        <img
          src={`${process.env.PUBLIC_URL}/img/logo.png`}
          alt="Fastigo logotyp"
          className="w-24 h-auto"
        />
      </div>
      <form
        onSubmit={handleSignup}
        className="mx-2 bg-fastigoWhite shadow-sm flex flex-col py-8 my-1 px-8 border border-darkGray mt-12 md:mx-0"
        style={{ width: 480, maxWidth: '100%' }}
      >
        <h1 className="font-semibold text-xl text-black">Ansökan om BankID-inloggning</h1>
        <div className="">
          <div className="py-4">
            <div className="pb-4 rounded-md">
              <p className="pb-8 text-sm opacity-75">
                Observera! För att ha rätt att lämna in företagsuppgifter måste ditt personnummer
                finnas registrerat i våra system.
              </p>
              <div className="flex flex-col">
                <label className="text-xs mt-3">Namn</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="shadow-sm h-12 mt-1 text-darkBlue appearance-none border rounded-sm w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                />
                <label className="text-xs mt-3">
                  E-postadress{' '}
                  {messages.email ? (
                    <span className="text-red font-semibold">{messages.email}</span>
                  ) : null}
                </label>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => {
                    setMessages({
                      ...messages,
                      email: emailRegex.test(e.target.value)
                        ? ''
                        : 'Fel format. Exempel: test@test.se',
                    })
                    setEmail(e.target.value)
                  }}
                  onFocus={() => setMessages({ ...messages, email: '' })}
                  className="shadow-sm h-12 mt-1 text-darkBlue appearance-none border rounded-sm w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                />
                <label className="text-xs mt-3">
                  Personnummer{' '}
                  {messages.ssn ? (
                    <span className="text-red font-semibold">{messages.ssn}</span>
                  ) : null}
                </label>
                <input
                  type="text"
                  value={ssn}
                  onChange={(e) => {
                    setMessages({
                      ...messages,
                      ssn: ssnRegex.test(e.target.value)
                        ? ''
                        : 'Ange i följande format: ÅÅÅÅMMDDXXXX',
                    })
                    setSsn(e.target.value)
                  }}
                  onFocus={() => setMessages({ ...messages, ssn: '' })}
                  className="shadow-sm h-12 mt-1 text-darkBlue appearance-none border rounded-sm w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="ÅÅÅÅMMDDXXXX"
                />

                <label className="text-xs mt-3">Organisationsnummer</label>
                <input
                  type="text"
                  value={orgNumber}
                  onChange={(e) => {
                    let newOrgNumber = e.target.value
                    if (newOrgNumber.length === 6) {
                      newOrgNumber += '-'
                    }
                    setOrgNumber(newOrgNumber)
                  }}
                  className="shadow-sm h-12 mt-1 text-darkBlue appearance-none border rounded-sm w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                />
                <label className="text-xs mt-3">Organisationsnamn</label>
                <input
                  type="text"
                  value={accountName}
                  onChange={(e) => setAccountName(e.target.value)}
                  className="shadow-sm h-12 mt-1 text-darkBlue appearance-none border rounded-sm w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>
          </div>
          <div
            className={
              !loading ? 'pb-4 flex flex-row justify-end' : 'pb-4 flex flex-row justify-center'
            }
          >
            {loading ? (
              <div className="w-full pb-4 flex flex-col justify-center items-center opacity-75 bg-lightGray border border-darkGray p-4 rounded-sm">
                <p className="text-darkBlue uppercase font-semibold text-xs p-2 pb-4">
                  Skickar in din ansökan...
                </p>
                <Spinner />
              </div>
            ) : (
              <button
                onClick={handleSignup}
                className="bg-headerBlue hover:bg-lightBlue text-fastigoWhite text-sm w-40 p-2 focus:outline-none focus:shadow-outline"
                type="button"
              >
                Skicka in din ansökan
              </button>
            )}
          </div>
        </div>
      </form>
      <button onClick={handleBackToLogin}>
        <p className="text-darkBlue mt-6 underline hover:font-semibold text-sm">
          Tillbaka till inloggning
        </p>
      </button>
    </div>
  )
}

export default BankIdSignup
